// @ts-nocheck
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  makeStyles,
  Box,
  Button,
  FormControlLabel,
  Switch,
  Icon,
} from '@material-ui/core';
import { GridOverlay, GridToolbarContainer } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../../common/components';
import { DateUtils } from '../../../../../common/utils';
import { useDialog } from '../../../../../common/hooks';
import PromotionPeriodForm from '../../common/PromotionPeriodForm';

const useStyles = makeStyles(theme => ({
  container: {
    flex: '1',
    height: '100%',
    minHeight: '500px',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
  dialog: {
    padding: '0',
    marginBottom: '0',
  },
  dialogContent: {
    display: 'flex',
    maxWidth: '1200px',
    overflow: 'hidden',
  },
  checkbox: {
    flex: '1',
    justifyContent: 'flex-start',
    pointerEvents: 'none',
  },
  actions: {
    display: 'flex',
    '& > .MuiButton-root': {
      marginRight: theme.spacing(1),
      '&:last-child': {
        marginRight: '0',
      },
    },
  },
}));

function PromotionPeriodTab(props) {
  const [t] = useTranslation();
  const { showDialog } = useDialog();
  const classes = useStyles();
  const [showActive, setShowActive] = useState(true);

  const {
    promotionId,
    periods,
    actionsDisabled,
    onCreatePeriod,
  } = props;

  const handleShowCreatePeriodDialog = () => {
    showDialog({
      title: t('promotion.promotionPeriodCreate'),
      content: params => (
        <Box className={classes.dialogContent}>
          <PromotionPeriodForm
            promotionId={promotionId}
            onSave={params.onConfirm}
            onCancel={params.onCancel}
            saveButtonText={t('common.create')}
          />
        </Box>
      ),
      onConfirm: onCreatePeriod,
      className: classes.dialog,
      throwOnError: true,
      hideFooter: true,
    });
  };

  const getColumnDefs = () => [
    {
      field: 'id',
      headerName: t('promotion.promotionPeriodId'),
      width: 200,
      flex: 1,
    },
    {
      field: 'startDate',
      headerName: t('promotion.promotionPeriodStartDate'),
      width: 250,
      type: 'date',
      valueFormatter: params => DateUtils.getDate(params.value),
      flex: 1,
    },
    {
      field: 'endDate',
      headerName: t('promotion.promotionPeriodEndDate'),
      width: 250,
      type: 'date',
      valueFormatter: params => DateUtils.getDate(params.value),
      flex: 1,
    },
  ];

  const getRowData = () => showActive ? periods.filter(period => DateUtils.isAfterToday(period.endDate)) : periods;

  const renderToolbar = () => (
    <GridToolbarContainer>
      <FormControlLabel
        className={classes.switch}
        control={
          <Switch
            id="PromotionPeriodTab-showActive"
            color="primary"
            checked={showActive}
            onChange={(e) => setShowActive(e.target.checked)}
            disabled={actionsDisabled}
          />
        }
        label={t('common.onlyActive')}
      />
      <Button
        id="PromotionPeriodTab-createPeriod"
        variant="outlined"
        color="primary"
        startIcon={<Icon>playlist_add</Icon>}
        onClick={handleShowCreatePeriodDialog}
        disabled={actionsDisabled}
      >
        {t('promotion.promotionPeriodCreate')}
      </Button>
    </GridToolbarContainer>
  );

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('common.empty')} />
    </GridOverlay>
  );

  return (
    <Box id="PromotionPeriodTab-container" className={classes.container}>
      <DataTable
        id="PromotionPeriodTab-table"
        components={{
          Toolbar: renderToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={periods.length}
        paginationMode="client"
        pagination
      />
    </Box>
  );
}

PromotionPeriodTab.propTypes = {
  promotionId: PropTypes.number.isRequired,
  periods: PropTypes.arrayOf(PropTypes.object).isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
  onCreatePeriod: PropTypes.func.isRequired,
};

export default PromotionPeriodTab;
